/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

// eslint-disable-next-line no-undef
export default new X2JS();
